import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-leaf-line text-primary-600 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                含羞草研究院
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注于知识探索、学习成长与自我提升的专业平台。帮助每一位求知者突破自我，开启全新的认知旅程。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              知识分类
            </h4>
            <nav className="flex flex-col gap-2.5">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              快速链接
            </h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                首页
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                关于我们
              </Link>
              <a href="/sitemap.xml" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                网站地图
              </a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              联系方式
            </h4>
            <div className="flex flex-col gap-2.5 text-sm text-foreground-600">
              <p>邮箱：contact@mimosa-research.cn</p>
              <p>地址：北京市海淀区中关村南大街5号</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 含羞草研究院. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}